var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProxeet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 315.64 315.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 83.95,
    y: 83.95,
    width: 147.74,
    height: 147.74,
    rx: 24.02,
    ry: 24.02,
    transform: "translate(-65.37 157.82) rotate(-45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m314.66,59.65l-64.39,64.39c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74l64.39-64.39c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m270.06,15.06l-64.39,64.39c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74L255.99.98c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m292.36,37.35l-64.39,64.39c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74l64.39-64.39c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m124.04,250.27l-64.39,64.39c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74l64.39-64.39c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m79.45,205.67L15.06,270.06c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74l64.39-64.39c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m101.75,227.97l-64.39,64.39c-1.46,1.46-4.03,1.27-5.74-.44l-7.89-7.89c-1.71-1.71-1.91-4.28-.44-5.74l64.39-64.39c1.46-1.46,4.03-1.27,5.74.44l7.89,7.89c1.71,1.71,1.91,4.28.44,5.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250.27,191.6l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44l-64.39-64.39c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m205.67,236.19l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44l-64.39-64.39c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m227.97,213.89l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44l-64.39-64.39c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m59.65.98l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44L45.58,15.06c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m15.06,45.58l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44L.98,59.65c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.35,23.28l64.39,64.39c1.46,1.46,1.27,4.03-.44,5.74l-7.89,7.89c-1.71,1.71-4.28,1.91-5.74.44L23.28,37.35c-1.46-1.46-1.27-4.03.44-5.74l7.89-7.89c1.71-1.71,4.28-1.91,5.74-.44Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProxeet);
export default __webpack_public_path__ + "static/media/proxeet_.b5143614a11223fdb877ef463a1a0b24.svg";
export { ForwardRef as ReactComponent };